import {AppConfig} from 'appConfig';
import {defaultsDeep} from 'lodash-es';
import {SignUpFlow} from '../enums/sign-up-flow';
import goCommonConfig from './go-common';

const API_ROOT_HOST = 'ci.go.digital';
const MD_URL = 'marketdata.go.digital/frontend';

const appConfigPartial: Partial<AppConfig> = {
    env: 'go-ci-client',

    /**
     * @type {ApiConfig}
     */
    api: {
        root: `https://${API_ROOT_HOST}/client-frontend`,

        marketDataStreaming:   `https://${MD_URL}/api/v2/stream`,
        quotesStreaming:       `https://${MD_URL}/api/v2/stream`,
        timeAndSalesStreaming: `https://${MD_URL}/api/v2/stream`,
        optionChainStreaming:  `https://${MD_URL}/api/v2/stream`,

        securities:       `https://${MD_URL}/api/v1/securities`,
        exchanges:        `https://${MD_URL}/api/v1/exchanges`,
        candles:          `https://${MD_URL}/api/v1/candles`,
        candlesStreaming: `https://${MD_URL}/api/v2/stream`,

        onboarding: 'api/v1/users/onboarding',
        apiKeys:    'api/v1/users/keys',

        investmentEntities:     'api/v1/users/investment-entities',
        portfolios:             'api/v1/users/portfolios',
        reports:                'api/v1/reports',
        assets:                 'api/v1/assets',
        autospreaderSecurities: 'api/v1/securities/autospreader',

        userAdmin: 'api/v1/user-admin',

        userDataStreaming:              'api/v2/stream',
        positionsStreaming:             'api/v2/stream',
        marketDataPrivateVwapStreaming: 'api/v2/stream',
        errorsStreaming:                'api/v2/stream',

        portfolioManagement: 'api/v1/pms'
    },

    localStorageKeyPrefix: 'go-digital/v1/client',

    voyager: {
        authFormUrl:  'https://trade-stage.cryptotrading-tech.com/oauth2/authorize',
        scope:        'global:rw',
        responseType: 'code',
        clientId:     'acb48050-dccc-4b63-b20c-5257fc40ecc9',
        redirectUri:  'https://ci.tigertrading.com/accounts/voyager-auth'
    },

    isSmartSecurityEnabled: true,

    signUpFlow: SignUpFlow.SIGN_UP,
    signUpEmailAsUsername: true,
    signUpInstantAccess: false,
    signUpWithoutApproval: true,
    signUpDisplayReferralIdInput: true,
    signUpOnboardingProcessSupport: true,

    resetPasswordFlow: true,

    signUpUrl: null, // Clear in order to use internal sign-up URL.

    simulatorAppConfig: {
        isSimulatorApp:             false,
        showSimulatorAppLink:       true,
        simulatorAppLinkUrl:        `https://simulator-${API_ROOT_HOST}/`,
        simulatorAppCookiesDomain:  '.go.digital',
        simulatorAppCookieLoginKey: 'goCISimLogin'
    }
};

export const goCiClientConfig: AppConfig = defaultsDeep(appConfigPartial, goCommonConfig);
export default goCiClientConfig;
